var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.showMapType,{tag:"component",staticClass:"elePatrol"})
}
var staticRenderFns = []

export { render, staticRenderFns }